import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBDataTable } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Descriptions, Popover   } from 'antd';

export default class Modelreportfacultylistterm extends Component {
    constructor(props) {
              super(props);
      this.state = {
        modal: false,
        term:'',
        datalist:[],    
      }

//this.handleChange = this.handleChange.bind(this);

}


componentDidMount(){
    setTimeout(() => {
        //ภายใน
        Axios.get('https://git.kpru.ac.th/FrontEnd_creditbank/administator/reportnumfacultylistterm/'+this.props.term+'/'+this.props.faculty)
        .then(res => {
        //  console.log(res.data.DetailListTeacher);
        //  this.setState({ bankname: res.data, loading: false })
       // const user_teacher = res.data.DetailListTeacher.filter( ({ user_teacher }) => user_teacher !== null );
      //  const user_teacher2 = user_teacher.filter( ({ user_teacher }) => user_teacher.substring(0, 1) !== 'T' );
         this.setState({ datalist: res.data})
        }) 
    }, 0);

}


toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
    this.componentDidMount()
  }

  

    render() {

        const text = <span>Title</span>;
const content = (
  <div>
    <p>Content</p>
    <p>Content</p>
  </div>
);

const buttonWidth = 70;


        const data = {
            columns: [
              {
                label: 'ลำดับ',
                field: 'list',
                sort: 'list',
                width: 150
              },
              {
                label: 'ชื่อหลักสูตร',
                field: 'Curriculumopen_Full_Name_TH',
                sort: 'Curriculumopen_Full_Name_TH',
                width: 270
              },
              {
                label: 'ชื่อ',
                field: 'Teacher_NAME',
                sort: 'Teacher_NAME',
                width: 270
              },
              {
                label: 'นามสกุล',
                field: 'Teacher_LASTNAME',
                sort: 'Teacher_LASTNAME',
                width: 200
              },
              {
                label: 'ภาคเรียน',
                field: 'Curriculumopen_TEAM',
                sort: 'Curriculumopen_TEAM',
                width: 100
              },
              {
                label: 'สถานะ',
                field: 'Curriculumopen_status',
                sort: 'Curriculumopen_status',
                width: 100
              }

            ],
  
            rows: [...this.state.datalist.map((data, i) => (
              {
                 list: <>{i+1}</>,
                 Curriculumopen_Full_Name_TH: <>{data.Curriculumopen_Full_Name_TH}</>,
                 Teacher_NAME: <>{data.Teacher_PNAME}{data.Teacher_NAME}</>,
                 Teacher_LASTNAME: <>{data.Teacher_LASTNAME}</>,
                 Curriculumopen_TEAM: <>{data.Curriculumopen_TEAM}</>,
                 Curriculumopen_status: <>    </>,
              

                 random: <h5 searchvalue={data.Curriculumopen_Full_Name_TH} >tourist <span className="badge badge-danger">narrow</span></h5>,
   
              }
             ))] 
        
        };


         const persons = <MDBDataTable
        // searching ={true}
         searchLabel="ค้นหา ชื่อหลักสูตร"
         striped
         bordered
         small 
         entries={20}
        // entriesOptions={["10", "20"]}
         order={["age", "desc"]}
         data={data}
         entriesLabel="จำนวนที่แสดง "
         infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
         paginationLabel={["ย้อนกลับ", "ถัดไป"]}
         responsive 
         sortRows={['random']}
         />


        return (
            <div>
            <MDBContainer>
            <MDBBtn onClick={this.toggle} size="sm"  color="indigo">ภาคเรียน</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
                <MDBModalHeader toggle={this.toggle}>ข้อมูลหลักสูตร ภาคเรียนที่ {this.props.term}</MDBModalHeader>
                <MDBModalBody>
                {persons} 
                </MDBModalBody>
                <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>Close</MDBBtn>
                <MDBBtn color="primary">Save changes</MDBBtn>
                </MDBModalFooter>
            </MDBModal>
            </MDBContainer>
            </div>
        )
    }
}
